import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Table,
} from "antd";
import React, { FC, useState } from "react";
import styled from "styled-components";
import { SETUP_PAYMENT } from "../../../Apollo/graphql/Mutation/SetupPayment";
import {
  GET_MY_BALANCE,
  GET_SINGLE_USER,
  LIST_PAYOUT,
  // MY_WEEKLY_ORDER,
} from "../../../Apollo/graphql/Query";

import { useMutation, useQuery } from "@apollo/client";
import { PAYOUT_MUTATION } from "../../../Apollo/graphql/Mutation/PayoutMutation";
import { EDIT_USER } from "../../../Apollo/graphql/Mutation/UserMutations";
import { replaceError, setUserData } from "../../../utils/utilsFunctions";

const ContextBox = styled.div`
  display: flex;
  .content-section {
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
  }
  .small-text {
    font-size: 14px;
  }
  .big-text {
    font-size: 20px;
  }
`;

const ProfileScreen: FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditUserModalVisible, setIsEditUserModalVisible] = useState(false);
  const [updateUserField, setUpdateUserField] = useState<any>({});

  const [payoutPrice, setPayoutPrice] = useState<any>();
  const [errorPrice, setErrorPrice] = useState("");
  const [done, setDone] = useState(false);

  const [setupPayment] = useMutation(SETUP_PAYMENT);
  const [payoutMutation] = useMutation(PAYOUT_MUTATION);
  const [updateUserMutation] = useMutation(EDIT_USER);
  
  const {data: userData} = useQuery(GET_SINGLE_USER);
  const { data: balanceData } = useQuery(GET_MY_BALANCE, {});

  const { data: payoutData, refetch } = useQuery(LIST_PAYOUT, {
    variables: {
      limit: 4,
    },
  });

  // const { data: myWeeklyOrderData } = useQuery(MY_WEEKLY_ORDER, {});
  const showEditUserModal = () => {
    setIsEditUserModalVisible(true);
  };

  const handleEditUserOk = async () => {
    setIsEditUserModalVisible(false);
    try {
      const res = await updateUserMutation({
        variables: {
          userId: userData?.me._id,
          input: {
            firstName: updateUserField.firstName,
            lastName: updateUserField.lastName
          },
        }
      })
      setUserData(JSON.stringify(res.data.updateUser))
      if (res) {
        notification.success({
          message: 'success',
          description: "User Updated Successfully"
        })
      }
    } catch (err) {
      replaceError(err)
    }
  };

  const handleEditUserCancel = () => {
    setIsEditUserModalVisible(false);
  };

  const totalAvailableBalance =
    balanceData?.myBalance?.availableBalance[0]?.amount / 100;

  const url = window.location.href;
  const myString = url.split("?")[1];
  const returnString = myString === "return";

  // const isSeller = user.isSeller === true;
  // const isPaymentSetUpComplete = user.paymentSetupComplete === true;

  const handleStripeAccount = async () => {
    const data: any = await setupPayment();
    if (data && data.data.setupPayment) {
      window.location.replace(data.data.setupPayment.url);
    }
  };
  const columns = [
    { title: "Amount", dataIndex: "amount", key: "amount" },
    { title: "Currecy", dataIndex: "currency", key: "currency" },
    { title: "Status", dataIndex: "status", key: "status" },
    { title: "Type", dataIndex: "type", key: "type" },
  ];
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    if (!done) {
      notification.error({
        message: "Error",
        description: "Something went Wrong",
      });
    } else {
      payoutMutation({
        variables: {
          payoutAmount: Number(payoutPrice),
        },
      })
        .then((res) => {
          notification.success({
            message: "Success",
            description: "Your payout is now being processed.",
          });
          refetch();
        })
        .catch((err) => {
          notification.error({
            message: "Error",
            description: replaceError(err),
          });
        });
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handlePayoutChange = (e: any) => {
    let input = e.target.value;
    if (input < 10) {
      setErrorPrice("Min payout price is AU$ 10");
      setDone(false);
    } else if (input > totalAvailableBalance) {
      setErrorPrice("Insufficient Balance");
      setDone(false);
    } else {
      setErrorPrice("");
      setPayoutPrice(input);
      setDone(true);
    }
  };

  return (
    <div style={{ paddingTop: "2rem", background: "white" }}>
      <Row style={{ width: "100%" }}>
        <Col md={{ span: 11 }} sm={{span:24}}>
          <ContextBox style={{ display: "flex" }}>
            <Avatar
              size={60}
              style={{ marginLeft: ".5rem", textTransform: "uppercase" }}
            >
              {userData?.me?.firstName?.trim()[0] || "U"}
            </Avatar>
            <div className="content-section">
              <div className="small-text">
                {" "}
                Since {userData?.me?.createdAt?.toString()?.trim()?.split("-")[0]},
              </div>
              <div className="big-text">
                {userData?.me?.firstName} {userData?.me?.lastName}
              </div>
              {/* {(isSeller ? (
                !isPaymentSetUpComplete ? (
                  <Button type="primary" onClick={handleStripeAccount}>
                    setup payment
                  </Button>
                ) : (
                  ""
                )
              ) : (
                ""
              )) ||
                (returnString && (
                  <Button type="primary" onClick={handleStripeAccount}>
                    setup payment
                  </Button>
                ))} */}
              <Button onClick={showEditUserModal} style={{width: 'fit-content'}}>Edit</Button>
            </div>

          </ContextBox>
        </Col>
        <Col md={{ span: 4 }} sm={{span:12}}>
          <ContextBox style={{ display: "flex" }}>
            {/* <div className="content-section">
              <div className="small-text">This week</div>
              <div className="big-text">${myWeeklyOrderData && myWeeklyOrderData?.myWeeklyOrder?.totalEstimatedEarningsThisWeek}</div>
              <div className="small-text">{myWeeklyOrderData && myWeeklyOrderData?.myWeeklyOrder?.totalOrdersThisWeek} orders</div>
            </div> */}
          </ContextBox>
        </Col>
        <Col md={{ span: 5 }} sm={{span:12}}>
          <ContextBox style={{ display: "flex" }}>
            <div className="content-section">
              <div className="small-text">Your Balance</div>
              <div className="big-text">
                {`AUD$ ${totalAvailableBalance > 0 ? totalAvailableBalance : 0 }`}
              </div>
              <div className="small-text">
                {`AUD$ ${totalAvailableBalance > 0 ? totalAvailableBalance : 0 }`} available
              </div>
            </div>
          </ContextBox>
        </Col>
        <Col md={{ span: 4 }}>
          <ContextBox style={{ display: "flex" }}>
            <div className="content-section">
              {
                userData?.me?.paymentSetupComplete ? (
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    onClick={showModal}
                  >
                    <p>Pay out now</p>
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    onClick={handleStripeAccount}
                  >
                    <p>Payment setup</p>
                  </Button>
                ) || (returnString && (
                  <Button type="primary" onClick={handleStripeAccount}>
                    setup payment
                  </Button>
                ))
              }
            </div>
          </ContextBox>
          <Modal
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            okButtonProps={{ disabled: done ? false : true }}
          >
            <h4>Enter amount to payout now</h4>
            <Input
              type="number"
              min="10"
              max={totalAvailableBalance}
              onChange={handlePayoutChange}
            />
            <span style={{ color: "red" }}>{errorPrice}</span>
          </Modal>

          <Modal visible={isEditUserModalVisible} onOk={handleEditUserOk} onCancel={handleEditUserCancel}>
            <Form
              name="basic"
              labelCol={{ span: 24 }}
              initialValues={{ remember: true }}
              autoComplete="off"
            >
              <Form.Item
                label="FirstName"
                name="firsName"
              // rules={[{ required: true, message: 'Please input your FirstName!' }]}
              >
                <Input
                  onChange={(e) => setUpdateUserField({ ...updateUserField, firstName: e.target.value })}
                />
              </Form.Item>

              <Form.Item
                label="LastName"
                name="lastName"
              // rules={[{ required: true, message: 'Please input your username!' }]}
              >
                <Input
                  onChange={(e) => setUpdateUserField({ ...updateUserField, lastName: e.target.value })}
                />
              </Form.Item>
            </Form>
          </Modal>
        </Col>
      </Row>
      <Row style={{ marginTop: "2rem" }}>
        <Col span={24}>
          <p style={{ marginLeft: ".5rem", fontSize: '16px' }}>Your Recent Payouts</p>
          <Table
            style={{ padding: '10px' }}
            bordered
            dataSource={payoutData?.listPayouts?.payouts}
            columns={columns}
          ></Table>
        </Col>
      </Row>
    </div>
  );
};
export default ProfileScreen;
